import React, { PureComponent } from 'react'

export default class LoadingComponent extends PureComponent {
	render() {
		return (
			<div className="loadEffect">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/party/pages/LoadingComponent.js